import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/pages/NotFound.scss';

const NotFound = () => {
  return (
    <motion.div 
      className="not-found-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container">
        <motion.div 
          className="content"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 100 }}
        >
          <div className="error-code">404</div>
          <h1>Página Não Encontrada</h1>
          <p>Desculpe, a página que você está procurando não existe ou foi removida.</p>
          
          <Link to="/" className="home-button">
            Voltar para a Página Inicial
          </Link>
        </motion.div>
        
        <motion.div 
          className="moon-animation"
          animate={{ 
            rotate: 360,
            scale: [1, 1.1, 1],
          }}
          transition={{ 
            rotate: { duration: 20, repeat: Infinity, ease: "linear" },
            scale: { duration: 3, repeat: Infinity, ease: "easeInOut" }
          }}
        >
          <div className="moon">
            <div className="crater crater-1"></div>
            <div className="crater crater-2"></div>
            <div className="crater crater-3"></div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default NotFound; 